export const expocadTempDocTypes = {
  booth: 'expocadBooth',
  exhibitor: 'expocadExhibitor',
}
